// extracted by mini-css-extract-plugin
export var container = "_jp-0";
export var segment = "_jp-2";
export var segmentActive = "_jp-3";
export var track = "_jp-1";